module.exports = __webpack_public_path__ + "img/allow-recording.4bb17f41.jpg";